export default "__VITE_ASSET__n_kcwS4E__"